<template>
  <div class="all">
    <!-- <Header></Header> -->
    <div class="box">
      <carousel></carousel>
      <div class="bottom">
        <download></download>
        <div class="text mShow">* These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.</div>
      </div>
      
    </div>
  </div>
</template>

<script>

import Carousel from '../../components/carousel.vue'
import Download from '../../components/Dowload.vue'
export default {
  components: {
    Carousel,
    Download
  },
  mounted() {
    // 问卷结果页曝光 埋点
    this.$sensors.track('QuestionnaireResultExpo', {
      source: 'ProductRecommend',
      hasProduct: this.$store.state.product.length > 0
    })
  },
}
</script>

<style lang="less" scoped>
@media only screen and (min-width: 767px) {
  .box {
    position: absolute;
    // padding-top: 72.5px;
    // z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .bottom-btn {
    flex-direction: column;
    justify-content: space-between;
    height: 120px;
    margin-top: 7px;
  }
}
.all {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  .swiper {
    margin-top: 20px;
  }
  .btn {
    text-align: center;
  }
  button {
    text-align: center;
    border: none;
    // margin-top: 80px;
    // padding-top: 108;
    width: 360px;
    height: 70px;
    background: #E26CA5;
    border-radius: 36px;
    font-size: 17px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 20.5px;
  }
  .download {
    margin-top: 25px;
    cursor: pointer;
    text-align: center;
    text-decoration:underline;
    font-size: 27px;
    font-family: Helvetica;
    color: #989898;
    line-height: 15.5px;
  }
  .text {
    margin-top: 8.5px;
    width: 306.5px;
    height: 36px;
    font-size: 10px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 150;
    color: #2C2C42;
    line-height: 12px;
  }
}
@media only screen and (max-width: 765px) {
  .bottom {
    // position: absolute;
    // bottom: 30px;
    margin-top: auto;
  }
  .bottom-btn {
    position: relative;
    top: -7px;
  }
  .box{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .all {
    min-height: 600px;
  width: 100%;
  // height: 100%;
  // overflow: hidden;
  // padding-bottom: 90px;
  padding-top: 72.5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .swiper {
    margin-top: 20px;
  }
  button {
    border: none;
    // position: relative;
    // margin-top: 63px;
    // padding-top: 108;
    margin: 0;
    width: 225px;
    height: 45px;
    background: #E26CA5;
    border-radius: 36px;
    font-size: 17px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 20.5px;
  }
  .download {
    cursor: pointer;
    text-decoration:underline;
    margin-top: 12.5px;
    font-size: 13px;
    font-family: Helvetica;
    color: #989898;
    line-height: 15.5px;
  }
  .text {
    margin-top: 8.5px;
    width: 340px;
    padding: 0 14px;
    height: 36px;
    margin-bottom: 30px;
    font-size: 10px;
    // transform: scale(0.7);
    font-family: Helvetica-Light, Helvetica;
    font-weight: 150;
    color: #2C2C42;
    line-height: 12px;
  }
}
}
</style>